export default /* html */ `<div class="inner-wrapper">
<p class="sub-title">식품 쇼핑, 오뚜기몰이랑 함께 해!</p>
<h2 class="coupon-title">오뚜기몰 신규회원 누구나 최대 10만원 할인</h2>
<div class="coupon">
  <img src="${require("../../../static/images/coupon-pack.png")}" alt="오뚜기몰 쿠폰 팩" />
  <div class="get-coupon-button">쿠폰팩 발급받기</div>
</div>
<div class="coupon-notice">
  <p class="notice-title">주의사항</p>
  <ul class="notice-list">
    <li>해당 쿠폰은 오뚜기몰 APP에서만 사용 가능합니다.</li>
    <li>오뚜기몰 신규 회원만 발급받을 수 있습니다.</li>
    <li>
      <strong>팔도, 삼양 제품</strong>에 한해 쿠폰을 사용할 수
      있습니다.
    </li>
    <li>쿠폰팩 이벤트는 회원 ID당 1회만 참여할 수 있습니다.</li>
    <li>발급된 쿠폰은 '마이페이지 > 쿠폰'에서 확인할 수 있습니다.</li>
    <li>
      진행 상황에 따라 이벤트 내용이 변경되거나 조기에 종료될 수
      있습니다.
    </li>
  </ul>
</div>
</div>`;
